import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { AgencySnapshotComponent } from './agency-snapshot.component';



@NgModule({
  declarations: [AgencySnapshotComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class AgencySnapshotModule { }
